// extracted by mini-css-extract-plugin
module.exports = {"tabText":"hotel-details-tabs_tabText__ALBiP","tabActiveText":"hotel-details-tabs_tabActiveText__0djcp","tabActiveBorder":"hotel-details-tabs_tabActiveBorder__zKCzB"};